import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-rule-form-has-string-user-field',
    templateUrl: './editor-eligibility-rule-form-has-string-user-field.component.html',
    standalone: false
})
export class EditorEligibilityRuleFormHasStringUserFieldComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  stringUserFieldNames: { id: string, name: string }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.stringUserFieldNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(stringUserFieldNames =>
        this.stringUserFieldNames = stringUserFieldNames
      );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getUserFieldName(): string {
    if (this.stringUserFieldNames === undefined) { return ''; }

    return this.stringUserFieldNames.find(
      userFieldName => userFieldName.id === this.formGroup.value.userField
    )?.name ?? $localize `Not valid`;
  }
}
